import './DayCard.scss'

import { useContext, useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import parse from 'html-react-parser'
import { getCoursePath } from 'components/common/helpers/Paths'
import { navigateTo } from 'components/common/navigation'
import { buildRequestURL } from 'components/common/api'
import CourseContext from 'components/common/contexts/CourseContext'

/**
 * Simple Day Card component. Used to display a course title and preview
 */
export default function DayCard({ lesson, style, returnPath, className = '' }) {
  const { courses } = useContext(CourseContext)
  const history = useHistory()
  const [courseLesson, setCourseLesson] = useState()
  const [course, setCourse] = useState()

  /**
   * Helper function to open the course page after clicking on it
   */
  const handleCardClick = (course, lesson) => {
    loadCourseLesson(course.id, lesson.id)
  }

  /**
   * Helper function to load the course on user tap/click
   * @param {Number} courseId The ID of the course to load
   */
  const loadCourseLesson = (courseId, lessonId) => {
    let url = getCoursePath(courseId)

    // Did we pass a custom returnPath?
    if (returnPath) url = buildRequestURL(url, { returnPath })

    url += `#${lessonId}`
    navigateTo(url, history)
  }

  useEffect(() => {
    if (!courses || !lesson) return
    const lessonCourse = courses.find(
      item => item.id === lesson.course || item.id === lesson.course_id
    )
    setCourse(lessonCourse)
    setCourseLesson(lesson)
  }, [courses, lesson])

  if (!lesson || !course) return null
  return (
    courseLesson && (
      <Card className={`my-3 lesson-card ${className}`} style={style}>
        {/* Click on the course title and open the ocurse */}
        <h5 className='lesson-course-title'>{parse(course.clean_title)}</h5>
        {/* Click on the course title and open the ocurse */}
        <h4
          className='lesson-title'
          onClick={event => handleCardClick(course, lesson)}
        >
          {(lesson.clean_title && parse(lesson.clean_title)) ||
            lesson.post_title}
        </h4>
      </Card>
    )
  )
}
